module.exports = __webpack_public_path__ + "static/babel-54fcf91eea6ee9c33b93233c8977a520.png";